import { render, staticRenderFns } from "./TemplateGroupHeader.vue?vue&type=template&id=468da611&scoped=true&"
import script from "./TemplateGroupHeader.vue?vue&type=script&lang=ts&"
export * from "./TemplateGroupHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateGroupHeader.vue?vue&type=style&index=0&id=468da611&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468da611",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VIcon,VRow,VTextField})
